import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { environment } from '@sbd-doug-frontend/app/environments/environment';
import { CathyService } from '@sbd-doug-frontend/app/services/cathy.service';
import { AccountFilesService } from '@sbd-doug-frontend/shared/lib/shared-services/account-files.service';
import { AccountFile, AccountFilesListResponse } from '@sbd-doug-frontend/shared/lib/types/file.types';
import { BehaviorSubject, catchError, EMPTY, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DougAccountFilesService extends AccountFilesService {

  constructor(
    private _httpClient: HttpClient,
    private _cathyService: CathyService,
  ) {
    super();
  }

  getAccountFiles(accountId: number, params?: Record<string, any>): Observable<AccountFilesListResponse> {
    this.accountFilesLoading.set(true);
    return this._httpClient.get<AccountFilesListResponse>(`${environment.apiBaseUrl}/api/v4/account/${accountId}/all-files`, { params })
      .pipe(
        map((response) => {
          this.accountFilesLoading.set(false);
          if (!response || response.success === false) {
            const msg = response?.message ?? 'Unable to load account files.';
            this._cathyService.error(msg);
            return response;
          }
          return response;
        }),
        catchError((err) => {
          this.accountFilesLoading.set(false);
          this._cathyService.error('Unable to load account files.');
          return EMPTY;
        })
      );
  }

  readFile(quoteRequestId: number, fileId: number): Observable<any> {
    return this._httpClient.get(`${environment.apiBaseUrl}/api/v4/quote-requests/read-file/${quoteRequestId}/${fileId}`, {
      responseType: 'blob'
    }).pipe(
      catchError((err) => {
        this._cathyService.error('Unable to read file.');
        return EMPTY;
      })
    );
  }
}
